import { createGlobalStyle } from 'styled-components'
import { reset } from './partials/reset.style'
import { typography } from './partials/typography.style'
import { locomotiveScrollStyles } from './partials/locomotiveScroll.style'
import { gatsbyTransitionLinkStyles } from './partials/gatsbyTransitionLink.style'
import { slick } from './partials/reactSlick.style'
import { slickTheme } from './partials/reactSlickTheme.style'
import { colors } from './vars/colors.style'
import { zIndex } from './vars/zIndex.style'
import { mq } from './vars/media-queries.style'

export const GlobalStyles = createGlobalStyle`
  ${reset}
  ${typography}
  ${locomotiveScrollStyles}
  ${gatsbyTransitionLinkStyles}
  ${slick}
  ${slickTheme}
  
  :root {
    --reach-tabs: 1;
  }

  * {
    -webkit-marquee-increment: 0vw; // This ensures that clamp values are updated on window resize in Safari
  }

  html,
  body {
    &.disable-scroll {
      // overflow: hidden;
      // overscroll-behavior: none;
      // position: relative;
      // touch-action: none;
      // height: calc((var(--vh) * 100) - 1px);

      ${mq.tabletL} {
        height: auto;
        overflow: hidden;
        overscroll-behavior: none;
        position: relative;
        touch-action: none;
      }

      #scroll-container {
        // overflow: hidden;
        // height: calc((var(--vh) * 100));

        ${mq.tabletL} {
          height: auto;
          overflow: visible;
        }
      }
    }
  }
  
  body {
    background-color: ${colors.light};
  }

  #portal {
    position: relative;
    z-index: ${zIndex.portal};
  }

  .react-parallax {
    height: 100%;
    overflow: hidden;
    transform: translateZ(0);
    width: 100%;
  }

  .react-parallax-background {
    height: 100%;
    position: relative;
    transform: scale(1.1);
    width: 100%;
  }
  .react-parallax-background-children {
    height: 100%;
    position: relative !important;
    width: 100%;
  }
`
